export const DEFAULT_LOCATION_FILTERS = [
  { id: 1, country: null, city: "", state: null },
];

/** Document Library: single location for now. Increase to allow multiple rows later. */
export const DOCUMENT_LIBRARY_MAX_LOCATION_ROWS = 1;

export const LOCATION_FILTER_DEBOUNCE_MS = 300;

/** Deep-clones location filter rows for sticky hydration / form state. */
export function cloneLocationFilters(filters) {
  if (!Array.isArray(filters) || filters.length === 0) {
    return DEFAULT_LOCATION_FILTERS.map((row) => ({ ...row }));
  }

  return filters.map((row, index) => ({
    id: row?.id ?? index + 1,
    country: row?.country ?? null,
    city: typeof row?.city === "string" ? row.city : "",
    state: row?.state ?? null,
  }));
}

export function countActiveLocationFilters(locationFilters) {
  return (locationFilters || []).filter(
    (filter) => filter.city || filter.state || filter.country
  ).length;
}

export function isLocationFilterActive(locationFilters) {
  return countActiveLocationFilters(locationFilters) > 0;
}

/** Maps location filter rows to API params (same shape as Discovery / Providers search). */
export function locationFiltersToApiParams(locationFilters) {
  const countries =
    locationFilters
      ?.map((filter) =>
        filter.country?.value === "US" ? "US" : filter.country?.label
      )
      .filter(Boolean) || [];

  const states =
    locationFilters
      ?.map((filter) => filter.state?.label)
      .filter(Boolean) || [];

  const cities =
    locationFilters
      ?.map((filter) => filter.city?.trim())
      .filter(Boolean) || [];

  return {
    ...(countries.length && {
      country_list: countries.map((c) => (c === "US" ? "USA" : c)),
    }),
    ...(states.length && { state_list: states }),
    ...(cities.length && { city_list: cities }),
  };
}
